import { Box, Fab, IconButton, List, useTheme } from '@mui/material'
import bigLogo from '../assets/images/big-logo.svg'
import React, { useContext } from 'react'
import SidebarAddButton from './SidebarAddButton';
import SidebarListItem from './SidebarListItem';
import { ReactComponent as Home } from '../assets/icons/home.svg';
import { ReactComponent as Users } from '../assets/icons/profile-2user.svg';
import { ReactComponent as Sellers } from '../assets/icons/shop.svg';
// import { ReactComponent as Suppliers } from '../assets/icons/weight.svg';
import { ReactComponent as Branch } from '../assets/icons/shop.svg';
import { ReactComponent as Banks } from '../assets/icons/bank.svg';
import { ReactComponent as Pos } from '../assets/icons/receipt-discount.svg';
import { ReactComponent as Reports } from '../assets/icons/document-copy.svg';
import { ReactComponent as LastUsers } from '../assets/icons/profile-tick.svg';
import { ReactComponent as Invoices } from '../assets/icons/document.svg';
import { ReactComponent as Setting } from '../assets/icons/setting.svg';
import { useLocation, useNavigate } from 'react-router-dom';
import { AuthContext } from '../contexts/AuthProvider';
import { Logout } from '@mui/icons-material';

export default function Sidebar() {

  const theme = useTheme();
  const loc = useLocation();
  const nav = useNavigate();
  const { role, logout, permissions } = useContext(AuthContext);

  return (
    <Box
      sx={{
        width: 270,
        background: theme.palette.secondary.main,
        display: 'flex',
        flexDirection: 'column',
        height: '100vh',
        position: 'fixed',
        top: 0,
        left: 0,
        zIndex: 1,
        overflowY: 'auto',
        '&::-webkit-scrollbar': {
          display: 'none'
        },
      }}
    >
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          mt: 3
        }}
      >
        <img
          src={bigLogo}
          alt="logo"
          style={{
            width: 200,
          }}
        />
      </Box>

      {role === 'admin' && (
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            gap: 2,
            mt: 7,
            px: 2
          }}
        >
          <SidebarAddButton
            label='Kuyumcu Ekle'
            onClick={() => nav('/admin/jewelers/new')}
          />
          {/* <SidebarAddButton
            label='Toptancı Ekle'
            onClick={() => nav('/admin/suppliers/new')}
          /> */}
        </Box>
      )}
      {role === 'seller' && (
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            gap: 2,
            mt: 7,
            px: 2
          }}
        >
          <SidebarAddButton
            label='Altın Sat'
            onClick={() => nav('/seller')}
          />
          {/* <SidebarAddButton
            label='Has Altın Al'
            onClick={() => nav('/')}
          /> */}
        </Box>
      )}

      {role === 'supplier' && (
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            gap: 2,
            mt: 7,
            px: 2
          }}
        >
          <SidebarAddButton
            label='Sipariş Takip'
            onClick={() => nav('/')}
          />
        </Box>
      )}

      {role === 'admin' && (
        <Box
          sx={{
            mt: 5
          }}
        >
          <List>
            <SidebarListItem
              label='Anasayfa'
              Icon={Home}
              to='/admin'
              selected={loc.pathname === '/admin'}
            />
            {permissions.includes('user:view_all') && <SidebarListItem
              label='Kullanıcılar'
              Icon={Users}
              to='/admin/users'
              selected={loc.pathname === '/admin/users'}
            />}
            {permissions.includes('jeweler:view_all') && <SidebarListItem
              label='Kuyumcular'
              Icon={Sellers}
              to='/admin/jewelers'
              selected={loc.pathname === '/admin/jewelers'}
            />}
            {/* <SidebarListItem
              label='Toptancılar'
              Icon={Suppliers}
              to='/admin/suppliers'
              selected={loc.pathname === '/admin/suppliers'}
            /> */}
            {/* <SidebarListItem
            label='Sözleşmeler'
            Icon={Contracts}
            to='/admin/contracts'
            selected={loc.pathname === '/admin/contracts'}
          /> */}
            {permissions.includes('bank_account:view_all') && <SidebarListItem
              label='Banka Hesapları'
              Icon={Banks}
              to='/admin/banks'
              selected={loc.pathname === '/admin/banks'}
            />}
            {permissions.includes('config:view') && <SidebarListItem
              label='POS Komisyon Oranları'
              Icon={Pos}
              to='/admin/pos-rates'
              selected={loc.pathname === '/admin/pos-rates'}
            />}
            {permissions.includes('report:view_all') && <SidebarListItem
              label='Raporlar'
              Icon={Reports}
              to='/admin/detailed-reports'
              selected={loc.pathname === '/admin/detailed-reports' || loc.pathname === '/admin/detailed-reports'}
            />}
             <SidebarListItem
              label='İşlem Geçmişi'
              Icon={LastUsers}
              to='/admin/transaction-history'
              selected={loc.pathname === '/admin/transaction-history'}
            />
             <SidebarListItem
              label='Faturalar'
              Icon={Invoices}
              to='/admin/invoices'
              selected={loc.pathname === '/admin/invoices'}
            />
          </List>
        </Box>
      )}

      {role === 'seller' && (
        <Box
          sx={{
            mt: 5
          }}
        >
          <List>
            <SidebarListItem
              label='Anasayfa'
              Icon={Home}
              to='/seller'
              selected={loc.pathname === '/seller'}
            />
            {/* <SidebarListItem
              label='Ürünler'
              Icon={Suppliers}
              to='/seller/products'
              selected={loc.pathname === '/seller/products'}
            /> */}
            {/* <SidebarListItem
              label='Toptancılar'
              Icon={Suppliers}
              to='/seller/suppliers'
              selected={loc.pathname === '/seller/suppliers'}
            /> */}
            {permissions.includes('bank_account:view_all') && <SidebarListItem
              label='Banka Hesapları'
              Icon={Banks}
              to='/seller/banks'
              selected={loc.pathname === '/seller/banks'}
            />}
            {permissions.includes('report:view_all') && <SidebarListItem
              label='Raporlar'
              Icon={Reports}
              to='/seller/detailed-reports'
              selected={loc.pathname === '/seller/detailed-reports' || loc.pathname === '/seller/detailed-reports'}
            />}
             <SidebarListItem
              label='Faturalar'
              Icon={Invoices}
              to='/seller/invoices'
              selected={loc.pathname === '/seller/invoices'}
            />
            {permissions.includes('branch:view_all') && <SidebarListItem
              label='Mağazalar'
              Icon={Branch}
              to='/seller/branches'
              selected={loc.pathname === '/seller/branches'}
            />}
            {permissions.includes('user:view_all') && <SidebarListItem
              label='Kullanıcılar'
              Icon={Users}
              to='/seller/users'
              selected={loc.pathname === '/seller/users'}
            />}
            {(permissions.includes('transaction:view_branch') || permissions.includes('transaction:view_own')) && <SidebarListItem
              label='İşlem Geçmişi'
              Icon={LastUsers}
              to='/seller/transaction-history'
              selected={loc.pathname === '/seller/transaction-history'}
            />}

            {/* <SidebarListItem
           label='Sözleşmeler'
           Icon={Contracts}
           to='/admin/contracts'
           selected={loc.pathname === '/admin/contracts'}
         /> */}



          </List>
        </Box>
      )}

      {role === 'supplier' && (
        <Box
          sx={{
            mt: 5
          }}
        >
          <List>
            <SidebarListItem
              label='Anasayfa'
              Icon={Home}
              to='/supplier'
              selected={loc.pathname === '/supplier'}
            />
            <SidebarListItem
              label='Banka Hesapları'
              Icon={Banks}
              to='/supplier/banks'
              selected={loc.pathname === '/supplier/banks'}
            />
            <SidebarListItem
              label='Raporlar'
              Icon={Reports}
              to='/supplier/reports'
              selected={loc.pathname === '/supplier/reports'}
            />

            <SidebarListItem
              label='Kullanıcılar'
              Icon={Users}
              to='/supplier/users'
              selected={loc.pathname === '/supplier/users'}
            />

            {/* <SidebarListItem
           label='Sözleşmeler'
           Icon={Contracts}
           to='/admin/contracts'
           selected={loc.pathname === '/admin/contracts'}
         /> */}



          </List>
        </Box>
      )}

      <Box
        sx={{
          flexGrow: 1,
        }}
      />
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          mb: 3
        }}
      >
        <IconButton onClick={() => { logout() }}>
          <Logout sx={{ color: 'white' }} />
        </IconButton>
        <Fab
          color='primary'
          size='small'
          onClick={() => nav(`${role}/profile`)}
        >
          <Setting
            style={{
              stroke: '#F1F1F1'
            }}
          />
        </Fab>
      </Box>
    </Box>
  )
}
